import React, { useEffect, useState } from 'react';
import { useMutation } from 'react-apollo';
import { InjectedRouter, locationShape, withRouter } from 'react-router';

import { useProfile } from '@/contexts/profile';
import LoadingEllipsis from '@/components/LoadingEllipsis';
import { ApproveOrganiserClaimByToken } from '@/state/services/gql/organiserClaim';
import getUrl from '@/routes/routes/helpers/getUrl';
import { logError } from '@/utils/logError';
import { useAuthService } from '@/contexts/authService';

type Props = {
  location: typeof locationShape;
  router: InjectedRouter;
};

function OrganiserClaimByTokenPage(props: Props): JSX.Element {
  const { location } = props;
  const { loading, refetch } = useProfile() || {};
  const authService = useAuthService();
  const claimToken = location?.query?.claimToken;
  const [errorOccurred, setErrorOccurred] = useState(!claimToken);

  const [approveClaimMutation] = useMutation(ApproveOrganiserClaimByToken);

  useEffect(() => {
    if (claimToken && !loading && refetch) {
      setErrorOccurred(false);
      approveClaimMutation({ variables: { token: claimToken } })
        .then(async (data: any) => {
          const organiserId =
            data?.data?.approveOrganiserClaimByToken?.organiserId;
          if (!organiserId) {
            setErrorOccurred(true);
            return;
          }
          if (refetch) {
            await refetch();
          }
          await authService.refresh();
          window.location.href = getUrl.organiserDashboard(organiserId);
        })
        .catch((error: any) => {
          logError(error, {
            errorMessageFallback: `Error while claiming organiser with claim token: ${claimToken}`,
            tags: null,
            data: null,
          });
          setErrorOccurred(true);
        });
    } else {
      setErrorOccurred(true);
    }
  }, [claimToken, loading, refetch]);

  return (
    <div>
      {errorOccurred ? (
        <h3>An error occurred. Please contact your account manager.</h3>
      ) : (
        <>
          <h3>Please wait while we set up your permissions.</h3>
          <LoadingEllipsis />
        </>
      )}
    </div>
  );
}

export default withRouter(OrganiserClaimByTokenPage);
